import { useState } from 'react';
import { useMutation } from 'react-query';

import { getRefundRateReportByManager } from 'src/apis/Reports/report.api';
import { TRefundRateReportData, TRefundRateReportRequest } from 'src/types/Reports/refundRate.model';
import { printMessage } from 'src/utils/commons/errors';

export default function useRefundRateReport() {
  const [listRefundReport, setListRefundReport] = useState<TRefundRateReportData>();

  const mutationGetRefundRateByTeam = useMutation(
    (param: TRefundRateReportRequest) => getRefundRateReportByManager(param),
    {
      onSuccess: async (response: any) => {
        if (response && response.succeeded) setListRefundReport(response.data);
      },
      onError: (error: any) => {
        printMessage(error.message);
      }
    }
  );

  return { mutationGetRefundRateByTeam, listRefundReport };
}
